import React from 'react';
import HttpsRedirect from 'react-https-redirect';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory as History } from 'history';
import './App.css';
import { Login, Deposit, Withdrawal, InternalTransfer, PaymentServices, Settings, Users, CurrencySettings, Profile, CustomerDocuments,RecoverPassword } from './views';
import { LanguageProvider, LanguageConsumer } from './contexts/Language';
import { AuthProvider, AuthRoute } from './contexts/Auth';
import { FetchLoading, AuthLoading } from './components/Loading';
import { Dashboard } from './views';
import { Page404, Page500, Page401 } from './views/ErrorPages';
import { Rules } from './views/PaymentServices/Rules';
import { WhiteList } from './views/PaymentServices/WhiteList';
import { BlackList } from './views/PaymentServices/BlackList';
import { PageRole } from './views/PaymentServices/PageRole';
import { DailyLimit } from './views/PaymentServices/DailyLimit';
import { CryptoWallet } from './views/Crypto/Wallet';
import { erc20Wallet} from './views/Crypto/erc20Wallet';
import { trc20Wallet } from './views/Crypto/trc20Wallet';
import { CryptoQr } from './views/Crypto/Qr';
import './components/Utilities';
import { CoinAddressList } from './views/Crypto/CoinAddressList';
import 'react-data-table-component-extensions/dist/index.css';


function App() {
  return (
    <HttpsRedirect>
      <Router history={History()}>
        <FetchLoading />
        <AuthLoading />
        <AuthProvider>
          <LanguageProvider>
            <LanguageConsumer>
              {() => (
                <Switch>
                  <Route exact path="/login" component={Login} />
                  <Route exact path="/recoverpassword" component={RecoverPassword} />

                  {/* AUTH ROUTE */}
                  <AuthRoute exact path={["/dashboard", "/home", "/"]} component={Dashboard} />

                  {/* MONEY TRANSFER */}
                  <AuthRoute exact path="/deposit" component={Deposit} />
                  <AuthRoute exact path="/withdrawal" component={Withdrawal} />
                  <AuthRoute exact path="/internal-transfer" component={InternalTransfer} />

                  {/* CRYPTO */}
                  <AuthRoute exact path="/crypto-wallet" component={CryptoWallet} />
                  <AuthRoute exact path="/crypto-erc20wallet" component={erc20Wallet} />
                  <AuthRoute exact path="/crypto-trc20wallet" component={trc20Wallet} />
                  <AuthRoute exact path="/crypto-qrcode" component={CryptoQr} />
                  <AuthRoute exact path="/coin-address-list" component={CoinAddressList} />

                  {/* TRANSFER OPTIONS */}
                  <AuthRoute exact path="/payment-services" component={PaymentServices} />
                  <AuthRoute exact path="/rules" component={Rules} />
                  <AuthRoute exact path="/daily-limit" component={DailyLimit} />
                  <AuthRoute exact path="/white-list" component={WhiteList} />
                  <AuthRoute exact path="/black-list" component={BlackList} />
                  <AuthRoute exact path="/page-role" component={PageRole} />

                  {/* COMMON */}
                  <AuthRoute exact path="/customer-documents" component={CustomerDocuments} />
                  <AuthRoute exact path="/profile" component={Profile} />
                  <AuthRoute exact path="/users" component={Users} />
                  <AuthRoute exact path="/settings" component={Settings} />
                  <AuthRoute exact path="/currency-settings" component={CurrencySettings} />

                  {/* 404 */}
                  <Route exact path={"/500"} component={Page500} />
                  <Route exact path={"/401"} component={Page401} />
                  <Route component={Page404} />
                </Switch>
              )}
            </LanguageConsumer>
          </LanguageProvider>
        </AuthProvider>
      </Router>
    </HttpsRedirect>
  );
}

export default App;
